<template>
    <div
        class="accordion"
        :class="classAccordion"
    >
        <div
            class="title"
            tabindex="0"
            @click.prevent.stop="toggle"
            @keypress.enter.prevent.stop="toggle"
        >
            <slot name="title"> </slot>
        </div>

        <div class="content">
            <div
                ref="wrapper"
                class="cw"
            >
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, ref, useTemplateRef, watch } from 'vue'
import { useElementSize } from '@vueuse/core'

const { isOpen } = defineProps<{
    isOpen: boolean
}>()

const emit = defineEmits<{
    'toggle': []
}>()

const toggle = () => {
    emit('toggle')
}

const wrapper = useTemplateRef('wrapper')
const { height } = useElementSize(wrapper, undefined, { box: 'border-box' })
const heightProperty = ref(`${height.value}px`)
watch(
    height,
    (h) => {
        // avoids excessive animation on modal open
        if (h) {
            heightProperty.value = `${h}px`
        }
    },
    { immediate: true }
)

const classAccordion = computed(() => ({
    'open': isOpen,
}))
</script>

<style scoped>
.accordion {
    --time-open: 0.2s;
    --time-close: 0.12s;
    border-bottom: 1px solid var(--grey-200);
    position: relative;

    .title {
        cursor: pointer;
    }

    .content {
        height: 0;
        opacity: 0;
        transition: all var(--time-close)
            var(--timing-function-easing-emphasized);
        overflow: hidden;
    }

    &.open {
        .content {
            height: v-bind(heightProperty);
            opacity: 1;
            transition: all var(--time-open)
                var(--timing-function-easing-emphasized-reverse);
        }
    }
}
</style>
